import { getAgencySettings } from "../queries/agencySettings";
import { useQuery } from "react-query";
import useNetworkHeaders from "./useNetworkHeaders";

export function useTimezone({ defaultToAgencyTimezone = true }: { defaultToAgencyTimezone?: boolean } = {}) {
  const networkHeaders = useNetworkHeaders();

  const { data, isLoading } = useQuery("agencySettings", getAgencySettings(networkHeaders), {
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
  });

  const clientTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const clientIsInAgencyTimezone = data?.timezoneInfo.timezone === clientTimezone;

  const agencyTimezoneInfo = data?.timezoneInfo;
  const startOfFiscalYear = data?.startOfFiscalYear;
  const daysOff = data?.daysOff.map((day: string) => new Date(day));
  const clientTimezoneInfo = {
    timezone: clientTimezone,
    utcOffset: new Date().getTimezoneOffset() / -60,
  };

  const defaultTimezoneInfo = defaultToAgencyTimezone
    ? agencyTimezoneInfo ?? clientTimezoneInfo // Fallback to client timezone if agency timezone is not set
    : clientTimezoneInfo;

  return {
    agencyTimezoneInfo,
    clientTimezoneInfo,
    defaultTimezoneInfo,
    clientIsInAgencyTimezone,
    startOfFiscalYear,
    daysOff,
    isLoading,
  };
}
